// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__hsIey","box":"WorkspacesBox_box__3MWa8","node":"WorkspacesBox_node__6gCNS"};